var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWedding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 377,
    height: 441,
    viewBox: "0 0 377 441",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.6726 209.23C51.6726 162.226 89.9089 123.98 136.942 123.98C183.917 123.98 222.163 162.226 222.163 209.23C222.163 237.799 208.044 263.125 186.424 278.6C182.563 286.506 180.375 295.39 180.375 304.797C180.375 315.897 183.405 326.32 188.689 335.223C238.199 314.804 273.145 266.038 273.145 209.24C273.145 147.139 231.377 94.6182 174.472 78.292L202.315 53.0721V18.0681C202.295 7.93566 194.098 0 183.975 0H89.8702C79.7474 0 71.4537 7.93566 71.4537 18.0681V53.0624L99.3543 78.2727C42.4111 94.6182 0.681152 147.129 0.681152 209.23C0.681152 264.393 33.6625 311.997 80.9474 333.404C79.2732 324.123 78.4119 314.562 78.4119 304.797C78.4119 294.229 79.4377 283.874 81.4023 273.858C63.189 258.219 51.6726 235.031 51.6726 209.23Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M296.236 180.701C297.901 189.962 298.772 199.485 298.772 209.23C298.772 219.847 297.746 230.221 295.762 240.276C313.869 255.925 325.366 279.035 325.366 304.787C325.366 351.792 287.129 390.057 240.125 390.057C193.101 390.057 154.865 351.801 154.865 304.787C154.865 276.122 169.101 250.709 190.876 235.225C194.708 227.366 196.847 218.531 196.847 209.211C196.847 198.082 193.779 187.669 188.485 178.746C138.907 199.137 103.903 247.941 103.903 304.778C103.903 379.886 165.007 440.99 240.125 440.99C315.214 440.99 376.318 379.886 376.318 304.778C376.318 249.693 343.424 202.127 296.236 180.701Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWedding);
export default __webpack_public_path__ + "static/media/wedding.b82eb4cf34c8f09a02ef75912ca9a7e9.svg";
export { ForwardRef as ReactComponent };